import { render, staticRenderFns } from "./ContactsPage.vue?vue&type=template&id=dc09e8a2&scoped=true&"
import script from "./ContactsPage.vue?vue&type=script&lang=js&"
export * from "./ContactsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc09e8a2",
  null
  
)

export default component.exports